

import styled from 'styled-components'
const StyledUl = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
`
const StyledArticle = styled.article`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  h1{
      font-size: 2.5rem;
      font-weight: 300;
  }
`;
const StyledLink = styled.a`
  :link,
  :visited{
    color: inherit;
    letter-spacing: 1px;
  }
`;
const About = () => {
    return (
      <StyledArticle>
        <h1>About Hair Definition.</h1>
        <p>Hair Definition is a fictional hair salon company.</p>
        <p>
          Design Credit:{" "}
          <a href="https://www.linkedin.com/in/exploit-enomah-b62289225/">
            Exploit Enomah
          </a>
        </p>
        <h4>Image Credits: </h4>
        <StyledUl>
          <li>
            <StyledLink href="https://unsplash.com/@bayleejadegramling?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Baylee Gramling
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@awcreativeut?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Adam Winger
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/salon?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@bayleejadegramling?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Baylee Gramling
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/hair-salon?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@angelopantazis?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Angelo Pantazis
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/hairstyles?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@lindsaymcgrath?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Lindsay McGrath
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/hairstyles?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@nicobaby?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Nico
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/spa?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@awcreativeut?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Adam Winger
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/hair-salon?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
          <li>
            <StyledLink href="https://unsplash.com/@tamarabellis?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Tamara Bellis
            </StyledLink>{" "}
            on{" "}
            <StyledLink href="https://unsplash.com/s/photos/hair-salon?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
            </StyledLink>
          </li>
        </StyledUl>
      </StyledArticle>
    );
}

export default About
